import './style/FooterComponent.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useRef, useState, useEffect, useContext } from 'react';
import linkedIn from './image/linkedin.png';
import faceBook from './image/facebook.png';
import twitter from './image/twitter.png';
import instagram from './image/instagram.png';
import icon2 from './image/colorixlogofull.png'; 
import { Button } from 'bootstrap';
import { useLanguage } from './LanguageContext';
import axios from 'axios';



function FooterComponent() {

    const { language } = useLanguage();
    const [Footercat, setFootercat] = useState([]);
    const [Contacts, setContact] = useState([]);
     useEffect(() => {
      if (language === 'FR') {
        const cachednavbarbardatafr = JSON.parse(localStorage.getItem('navbarbardatafr'));
        const cachednavbarContactfr = JSON.parse(localStorage.getItem('navbarContactfr'));
        if (cachednavbarbardatafr && cachednavbarContactfr) {
          // If images are found in localStorage, use them
          setFootercat(cachednavbarbardatafr);
          setContact(cachednavbarContactfr);
        } else {
    
          axios.get('https://colorixbackend.seuytel.com/navbarfr')
            .then(response => {
              const categoryItems = response.data.filter(item => item.page_group === 'Category');
              setFootercat(categoryItems);
              localStorage.setItem('navbarbardatafr', JSON.stringify(response.data));


              // Filter for only page_group === "Service"
              const ContactItems = response.data.filter(item => item.page_group === "Contact_formular");

              // Parse the JSON value string and return usable data
              const parsedContact = ContactItems.map(item => {
                let parsedContactValue = {};
                try {
                  parsedContactValue = JSON.parse(item.value);
                } catch (e) {
                  console.error("Error parsing value:", item.value);
                }

                return {
                  title: item.page_part,
                  input_1: parsedContactValue.input_1,
                  input_2: parsedContactValue.input_2,
                  input_3: parsedContactValue.input_3,
                  input_4: parsedContactValue.input_4,
                  input_5: parsedContactValue.input_5,
                  placeholder_1: parsedContactValue.placeholder_1,
                  placeholder_2: parsedContactValue.placeholder_2,
                  placeholder_3: parsedContactValue.placeholder_3,
                  placeholder_4: parsedContactValue.placeholder_4,
                  placeholder_5: parsedContactValue.placeholder_5,
                  button: parsedContactValue.button,
                };
              });


              setContact(parsedContact);
              localStorage.setItem('navbarContactfr', JSON.stringify(parsedContact));

            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });
    
    
          } 
        } else {
          const cachednavbarbardataen = JSON.parse(localStorage.getItem('navbarbardataen'));
          const cachednavbarContacten = JSON.parse(localStorage.getItem('navbarContacten'));
          if (cachednavbarbardataen && cachednavbarContacten) {
            // If images are found in localStorage, use them
            setFootercat(cachednavbarbardataen);
            setContact(cachednavbarContacten);
          } else {
        
            axios.get('https://colorixbackend.seuytel.com/navbaren')
              .then(response => {

                const categoryItems = response.data.filter(item => item.page_group === 'Category');
                setFootercat(categoryItems);
                localStorage.setItem('navbarbardataen', JSON.stringify(response.data));

                 // Filter for only page_group === "Service"
              const ContactItems = response.data.filter(item => item.page_group === "Contact_formular");

              // Parse the JSON value string and return usable data
              const parsedContact = ContactItems.map(item => {
                let parsedContactValue = {};
                try {
                  parsedContactValue = JSON.parse(item.value);
                } catch (e) {
                  console.error("Error parsing value:", item.value);
                }

                return {
                  title: item.page_part,
                  input_1: parsedContactValue.input_1,
                  input_2: parsedContactValue.input_2,
                  input_3: parsedContactValue.input_3,
                  input_4: parsedContactValue.input_4,
                  input_5: parsedContactValue.input_5,
                  placeholder_1: parsedContactValue.placeholder_1,
                  placeholder_2: parsedContactValue.placeholder_2,
                  placeholder_3: parsedContactValue.placeholder_3,
                  placeholder_4: parsedContactValue.placeholder_4,
                  placeholder_5: parsedContactValue.placeholder_5,
                  button: parsedContactValue.button,
                };
              });


              setContact(parsedContact);
              localStorage.setItem('navbarContacten', JSON.stringify(parsedContact));
              
              })
              .catch(error => {
                console.error('Error fetching data:', error);
              });
        
        
            } 
        }
      }, [language]);
    const Footercat0 = Footercat[0]?.value ? Object.values(JSON.parse(Footercat[0].value)) : [];
    const Footercat1 = Footercat[1]?.value ? Object.values(JSON.parse(Footercat[1].value)) : [];
    const Footercat2 = Footercat[2]?.value ? Object.values(JSON.parse(Footercat[2].value)) : [];
    const Footercat3 = Footercat[3]?.value ? Object.values(JSON.parse(Footercat[3].value)) : [];
    const Footercat4 = Footercat[4]?.value ? Object.values(JSON.parse(Footercat[4].value)) : [];

    

    const [isOpen, setIsOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    
      // Clean up on unmount just in case
      return () => {
        document.body.style.overflow = 'auto';
      };
    }, [isOpen]);
    
    const togglePopup = () => {
      if (isOpen) {
        setIsClosing(true); // start fadeOut
        setTimeout(() => {
          setIsOpen(false);
          setIsClosing(false);
        }, 300); // match fadeOut duration
      } else {
        setIsOpen(true);
      }
    };
   

    return  (
      <div className="footer-bg-color">
        <div className="container-xl d-flex flex-column">
          <div className="gone-layout-sm">
            <div className="d-flex flex-row justify-content-evently pt-5">
              <div className="d-flex flex-column me-auto">
                <span className="mb-4 fw-bold">{Footercat[0]?.page_part}</span>
                {Footercat0.map((val, index) => (
                <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                ))}
              </div>
              <div className="d-flex flex-column me-auto">
                <span className="mb-4 fw-bold ">{Footercat[1]?.page_part}</span>
                {Footercat1.map((val, index) => (
                <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                ))} 
                </div>
              <div className="d-flex flex-column me-auto">
                <span className=" mb-4 fw-bold ">{Footercat[2]?.page_part}</span>
                {Footercat2.map((val, index) => (
                <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                ))}
              </div>
              <div className="d-flex flex-column me-auto">
                <span className=" mb-4 fw-bold ">{Footercat[3]?.page_part}</span>
                {Footercat3.map((val, index) => (
                <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                ))}
              </div>
              <div className="d-flex flex-column">
                <span className="mb-4 fw-bold">{Footercat[4]?.page_part}</span>
                {Footercat4.map((val, index) => (
                <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                ))} 
              </div>
            </div>
            <div className="d-flex my-4 pt-3" style={{borderTop: '2px solid rgba(218, 203, 189, 0.45)', color:'GrayText'}}>
              <a className="me-auto" href="#" role='button' style={{color:'GrayText', textDecoration: 'none'}}>colorix-group.com</a>
              <span className="me-auto">Rue de la Province, DGSN Yaoundé - Cameroun</span> 
              <span className="me-auto">Tel: +237 691 86 82 82 / 696 26 26 56</span>
              <span>Copyright © 2019 - 2022</span>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column">
          <div className="gone-layout-lg">
            <div className="d-flex flex-column ps-3">
              <div className="d-flex flex-column pt-5">
                <span className="mb-4 fw-bold">{Footercat[0]?.page_part}</span>
                <div className="grid-container">
                  {Footercat0.map((val, index) => (
                  <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                  ))}
                </div>
              </div>
              <div className="d-flex flex-column pt-5">
                <span className="mb-4 fw-bold ">{Footercat[1]?.page_part}</span>
                <div className="grid-container">
                  {Footercat1.map((val, index) => (
                  <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                  ))}
                </div>
              </div>
              <div className="d-flex flex-column pt-5">
                <span className=" mb-4 fw-bold ">{Footercat[2]?.page_part}</span>
                <div className="grid-container">
                  {Footercat2.map((val, index) => (
                  <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                  ))}
                </div>
              </div>
              <div className="d-flex flex-column pt-5">
                <span className="mb-4 fw-bold ">{Footercat[3]?.page_part}</span>
                <div className="grid-container">
                  {Footercat3.map((val, index) => (
                  <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                  ))}
                </div>
              </div>
              <div className="d-flex flex-column pt-5">
                <span className="mb-4 fw-bold">{Footercat[4]?.page_part}</span>
                <div className="grid-container">
                  {Footercat4.map((val, index) => (
                  <a className="txt-color" href="frontend.seuytel.com" style={{width:"fit-content", maxWidth:"fit-content"}}>{val}</a>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="d-flex flex-column justify-content-center pt-3 pb-4 mt-4" style={{color:'GrayText', borderTop: '2px solid rgba(218, 203, 189, 0.45)', backgroundColor: 'rgba(207, 203, 198, 0.48)'}}>
              <a className="d-flex justify-content-center mb-2" href="#" role='button' style={{color:'GrayText', textDecoration: 'none'}}>colorix-group.com</a>
              <span className="d-flex justify-content-center mb-2">Rue de la Province, DGSN Yaoundé - Cameroun</span> 
              <span className="d-flex justify-content-center mb-2">Tel: +237 691 86 82 82 / 696 26 26 56</span>
              <span className="d-flex justify-content-center">Copyright © 2019 - 2022</span>
            </div>
          </div>
        </div>
         
     <button
     onClick={togglePopup}
     style={{
       position: 'fixed',
       bottom: '20px',
       right: '20px',
       padding: '10px 14px',
       backgroundColor: '#4CAF50',
       color: '#fff',
       fontWeight: '600',
       fontSize: '16px',
       border: 'none',
       borderRadius: '30px',
       boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
       cursor: 'pointer',
       transition: '0.3s',
       zIndex: 99,
     }}
   >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" fill="white"><path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg>
   </button>

   {/* Popup Modal */}
   {isOpen && (
    <div
    style={{
      animation: isClosing ? 'fadeOut 0.3s ease' : 'fadeIn 0.3s ease',
      ...styles.overlay
    }}
    onClick={togglePopup} // Click outside closes popup
  >
     
    <div style={{
      ...styles.popup,
      animation: isClosing ? 'fadeOut 0.3s ease' : 'scaleIn 0.3s ease'
    }}
    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
    >    
     {Contacts.map(Contact => (
   
         <h2 style={{ marginBottom: '15px', color:'#2A4D9B' }}>{Contact.title} </h2>
         
      ))}
         {Contacts.map(Contact => (
         <form style={styles.form}>
           <label style={styles.label}>{Contact.input_1} </label>
           <input type="text" placeholder={Contact.placeholder_1}  required style={styles.input} />

           <label style={styles.label}>{Contact.input_2}</label>
           <input type="text" placeholder={Contact.placeholder_2}  style={styles.input} />

           <label style={styles.label}>{Contact.input_3}</label>
           <input type="email" placeholder={Contact.placeholder_3}  required style={styles.input} />

           <label style={styles.label}>{Contact.input_4}</label>
           <input type="tel" placeholder={Contact.placeholder_4}  required style={styles.input} />

           <label style={styles.label}>{Contact.input_5}</label>
           <textarea
             placeholder={Contact.placeholder_5}
             rows="4"
             required
             style={styles.textarea}
           />

           <button type="submit" style={styles.submitButton}>{Contact.button}</button>
         </form>
         
      ))}
         <button onClick={togglePopup} style={styles.closeButton}>✖</button>
       </div>
     </div>
   )}
      </div>
      
    );
}


const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 99999999999999999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    animation: 'fadeIn 0.3s ease-in-out',
  },
  popup: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '10px',
    width: '84%',
    minWidth: '320px',
    maxWidth: '520px',
    boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
    position: 'relative',
    animation: 'scaleIn 0.3s ease-in-out',
    maxHeight: '98vh',           // Max height before scroll kicks in
    overflowY: 'auto'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '-6px',
    marginTop: '8px',
  },
  input: {
    padding: '10px 14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    outline: 'none',
  },
  textarea: {
    padding: '10px 14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    resize: 'vertical',
    outline: 'none',
  },
  submitButton: {
    marginTop: '12px',
    padding: '12px',
    backgroundColor: '#22c55e',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
    fontSize: '15px',
    cursor: 'pointer',
    transition: 'background 0.3s ease',
  },
  closeButton: {
    position: 'absolute',
    top: '14px',
    right: '14px',
    background: 'none',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
    color: '#666',
  },
};

export default FooterComponent;